/**
 DO NOT add local, transient, router, or any non-global state to this file.
 **/

import { NotificationPreferences, PortfolioPermissions, UserPortfolio, userViewOverrides } from '@bakerweb/models';
import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

export const userPortfolioAtom = atom<UserPortfolio[]>([]);

export const userEmail = atom<string>('');

export const userOverridesAtom = atom<userViewOverrides>({
  houstonTrust: false,
  pledging: false,
  apm: false,
  files: false,
  cds: false,
  muniCredit: false
});

export const userNotificationPreferencesAtom = atom<NotificationPreferences>();

export const portfolioPermissionsAtom = atom<PortfolioPermissions>({
  bba: false,
  apm: false,
  bsm: false,
  irrmReporting: false,
  irrm: false,
  offerings: false,
  dailyPricing: false,
  dailyPricingItemLimit: 0
});

export const selectedPortfolioAtom = atomWithStorage<UserPortfolio | undefined>(
  'selectedPortfolio',
  undefined,
  createJSONStorage(),
  { getOnInit: true }
);

export const selectedAsOfDateAtom = atomWithStorage<string>('selectedAsOfDate', '', createJSONStorage(), {
  getOnInit: true
});

export const selectedBakerFedIDAtom = atom<string>('');

export const selectedCashFlowAtom = atomWithStorage<string>('selectedCashFlow', 'default', createJSONStorage(), {
  getOnInit: true
});

export const selectedCashflowFrequencyAtom = atomWithStorage<string>(
  'selectedFrequency',
  'monthly',
  createJSONStorage(),
  {
    getOnInit: true
  }
);

export const showChartAnnualCfAtom = atomWithStorage('showChartAnnualCf', true, createJSONStorage(), {
  getOnInit: true
});

export const showChartMonthlyCfAtom = atomWithStorage('showChartMonthlyCf', true, createJSONStorage(), {
  getOnInit: true
});

export const houstonTrustTabIndexAtom = atomWithStorage('houstonTrustTabIndex', 0, createJSONStorage(), {
  getOnInit: true
});
